import { EventsSettingsModel } from '@/domain/models'
import { GetEventsSettings } from '@/domain/usecases'
import { RemoteGetEventsSettings } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import env from '@/main/config/env'

export const makeGetEventsSettings = (): GetEventsSettings => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<EventsSettingsModel>()

  return new RemoteGetEventsSettings(url, httpClient)
}
